import { render, staticRenderFns } from "./classhourSpendList.vue?vue&type=template&id=b4807212&scoped=true&"
import script from "./classhourSpendList.vue?vue&type=script&lang=js&"
export * from "./classhourSpendList.vue?vue&type=script&lang=js&"
import style0 from "./classhourSpendList.vue?vue&type=style&index=0&id=b4807212&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4807212",
  null
  
)

export default component.exports